import { api } from '../index';

const prefix = '/api/shopify/common/';

export function apiGetShopifyStoreList() {
	return api.get(prefix + 'getShopifyStoreList');
}

export function apiSetThirdPartyStoreSetting(store_no) {
	return api.get(prefix + 'setThirdPartyStoreSetting', { params: { store_no } });
}
